import { render, staticRenderFns } from "./scroll-gift.vue?vue&type=template&id=505c5248&scoped=true&lang=pug&"
import script from "./scroll-gift.vue?vue&type=script&lang=js&"
export * from "./scroll-gift.vue?vue&type=script&lang=js&"
import style0 from "./scroll-gift.vue?vue&type=style&index=0&id=505c5248&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505c5248",
  null
  
)

export default component.exports